<template>
  <v-dialog
    :value="isShowingPlaylistCreatedDialog"
    max-width="630px"
    class="highestZIndex"
    @click:outside="clickedAway"
  >
    <v-card class="pa-5">
      <v-alert icon="mdi-web" text class="playlistCreatedURL" type="info">
        {{ newPlaylistURL }}
      </v-alert>
      <v-row class="d-flex align-center">
        <v-col>
          <v-btn color="secondary" block outlined @click="copyToClipboard">
            Copy To Clipboard
          </v-btn>
        </v-col>
        <v-col>
          <v-btn color="secondary" block depressed @click="openInANewTab">
            Open In A New Tab
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PlaylistCreatedDialog',
  
  computed: {
    ...mapGetters({
      isShowingPlaylistCreatedDialog: 'playlist/isShowingPlaylistCreatedDialog',
      newPlaylistURL: 'playlist/newPlaylistURL',
    }),
  },
  
  methods: {
    ...mapActions({
      resetPlaylist: 'playlist/resetPlaylist',
      showSnackbar: 'ui/showSnackbar',
    }),
    
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.newPlaylistURL);
        this.showSnackbar('Copied to clipboard!');
      } catch (error) {
        console.error('Problem copying to clipboard:', error);
        this.showSnackbar('Failed to copy to clipboard');
      }
    },
    
    openInANewTab() {
      window.open(this.newPlaylistURL);
    },
    
    clickedAway() {
      this.resetPlaylist();
    }
  }
};
</script>

<style scoped>
.highestZIndex {
  z-index: 999999999 !important;
}

.playlistCreatedURL {
  overflow-wrap: anywhere;
}
</style>